export default __webpack_public_path__ + "static/media/BG-LightBlue-0007.788dc10f.png";